'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('../../node_modules/vue/dist/vue.js');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    categories: [],
    activeCategory: 0,
    assessmentId: null,
    questionLoading: false,
    resultSimulationInfo: null,
    url: {},
    siteUpdates: {}
  },
  actions: {
    setUrls: function setUrls(store, payload) {
      store.state.url.getUrl = payload.getUrl;
      store.state.url.submitAssessmentUrl = payload.submitAssessmentUrl;
      store.state.url.submitQuestionUrl = payload.submitQuestionUrl;
      store.state.url.submitQuestionCommentUrl = payload.submitQuestionCommentUrl;
      store.state.url.exitUrl = payload.exitUrl;
      store.state.url.getSiteUpdateUrl = payload.getSiteUpdateUrl;
      store.state.url.postSiteUpdateUrl = payload.postSiteUpdateUrl;
    },
    setAssessmentId: function setAssessmentId(store, payload) {
      store.state.assessmentId = payload;
    },
    loadAssessment: function loadAssessment(store, payload) {
      store.state.assessmentId = parseInt(payload.assessmentId);

      var uri = store.state.url.getUrl;
      _vue2.default.axios.get(uri).then(function (response) {
        store.state.categories = response.data.questionCategorys;

        if (response.data.currentCategoryId !== undefined) {
          var categoryIndex = store.state.categories.findIndex(function (category) {
            return category.id === response.data.currentCategoryId;
          });

          if (categoryIndex >= 0) {
            store.state.activeCategory = categoryIndex;
          }
        }
        if (response.data.questionResults && response.data.resultSimulationInfo) {
          store.commit('initSimulationData', response);
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    getQuestion: function getQuestion(store, payload) {
      if (typeof store.state.categories[payload.categoryId].questions !== 'undefined') {
        var categoryQuestions = store.state.categories[payload.categoryId].questions;
        return categoryQuestions.find(function (question) {
          return question.id === payload.questionId;
        });
      }
    },
    submitAssessment: function submitAssessment(store, payload) {
      return _vue2.default.axios.post(store.state.url.submitAssessmentUrl, payload);
    },
    submitQuestion: function submitQuestion(store, payload) {
      return _vue2.default.axios.post(store.state.url.submitQuestionUrl, payload);
    },
    submitQuestionComment: function submitQuestionComment(store, payload) {
      return _vue2.default.axios.post(store.state.url.submitQuestionCommentUrl, payload);
    },
    loadSiteUpdates: function loadSiteUpdates(store) {
      var uri = store.state.url.getSiteUpdateUrl;
      _vue2.default.axios.get(uri).then(function (response) {
        store.commit('setSiteUpdateData', response.data);
      }).catch(function (error) {
        console.error(error);
      });
    },
    setSiteUpdates: function setSiteUpdates(store, payload) {

      var measures = {};
      store.state.siteUpdates.measures.forEach(function (measure) {
        if (measure.id == payload.id) {
          var id = measure.id;
          var item = _defineProperty({}, parseInt(id), payload.plannedToExecute);
          measures = Object.assign(measures, item);
        } else {
          if (typeof measure.plannedToExecute !== 'undefined') {
            var _id = measure.id;

            var _item2 = _defineProperty({}, parseInt(_id), measure.plannedToExecute === true ? 'true' : 'false');
            measures = Object.assign(measures, _item2);
          }
        }
      });

      var data = {
        "assessmentId": store.state.assessmentId,
        "measures": measures
      };

      var uri = store.state.url.postSiteUpdateUrl;
      _vue2.default.axios.post(uri, data).then(function (response) {
        store.commit('setSiteUpdateData', response.data.customData.siteUpdateResponse);
      }).catch(function (error) {
        console.error(error);
      });
    }
  },
  mutations: {
    toggleAnswers: function toggleAnswers(state, payload) {
      if (payload.displayQuestions && Object.keys(payload.displayQuestions).length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {

          for (var _iterator = state.categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var category = _step.value;

            var questions = category.questions;

            var _loop = function _loop(key) {
              var questionIndex = questions.findIndex(function (question) {
                return question.id === parseInt(key);
              });

              if (questionIndex >= 0) {
                var question = category.questions[questionIndex];

                var value = payload.displayQuestions[key];

                question.display = value;
                if (payload.questionResults) {
                  question.appliedPenalty = payload.questionResults[key].penalty;
                  question.reductionFactor = payload.questionResults[key].reductionFactor;
                  _vue2.default.set(question, 'appliedPenalty', question.appliedPenalty);
                  _vue2.default.set(question, 'reductionFactor', question.reductionFactor);
                }

                if (question.display === false) {

                  if (question.answer === undefined) {
                    _vue2.default.set(question, 'answer', '');
                  } else {
                    question.answer = '';
                  }
                }
              }
            };

            for (var key in payload.displayQuestions) {
              _loop(key);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (payload.resultSimulationInfo && Object.keys(payload.resultSimulationInfo).length > 0) {
          state.resultSimulationInfo = payload.resultSimulationInfo;
        }
      }
    },
    initSimulationData: function initSimulationData(state, payload) {
      state.categories.forEach(function (category) {
        category.questions.forEach(function (question) {
          _vue2.default.set(question, 'appliedPenalty', payload.data.questionResults[question.id].penalty);
          _vue2.default.set(question, 'reductionFactor', payload.data.questionResults[question.id].reductionFactor);
        });
      });

      if (payload.data.resultSimulationInfo && Object.keys(payload.data.resultSimulationInfo).length > 0) {
        state.resultSimulationInfo = payload.data.resultSimulationInfo;
      }
    },
    setQuestionLoading: function setQuestionLoading(state, payload) {
      state.questionLoading = payload.loading;
    },
    setQuestionsValidity: function setQuestionsValidity(state, payload) {

      var categoryQuestions = state.categories[state.activeCategory].questions;
      var questionValidations = payload.questionValidations;

      _lodash2.default.forEach(questionValidations, function (answer, id) {
        var questionIndex = categoryQuestions.findIndex(function (item) {
          return item.id === parseInt(id);
        });

        if (questionIndex >= 0) {

          if (categoryQuestions[questionIndex] !== undefined) {

            if (categoryQuestions[questionIndex].valid === undefined) {
              _vue2.default.set(categoryQuestions[questionIndex], 'valid', answer);
            } else {
              categoryQuestions[questionIndex].valid = answer;
            }
          }
        }
      });
    },
    setCategoryComment: function setCategoryComment(state, payload) {
      if (payload.categoryKey >= 0 && payload.comment.length > 0) {

        if (state.categories[payload.categoryKey].comment === undefined) {
          _vue2.default.set(state.categories[payload.categoryKey], 'comment', payload.comment);
        } else {
          state.categories[payload.categoryKey].comment = payload.comment;
        }
      }
    },
    setQuestion: function setQuestion(state, payload) {

      if (state.categories[state.activeCategory].questions !== undefined) {

        var categoryQuestions = state.categories[state.activeCategory].questions;
        var _questionIndex = categoryQuestions.findIndex(function (question) {
          return question.id === payload.questionId;
        });
        if (_questionIndex >= 0) {

          if (payload.answer !== undefined) {
            if (categoryQuestions[_questionIndex].answer === undefined) {
              _vue2.default.set(categoryQuestions[_questionIndex], 'answer', payload.answer);
            } else {
              categoryQuestions[_questionIndex].answer = payload.answer;
            }
          }

          if (payload.valid !== undefined) {
            if (categoryQuestions[_questionIndex].valid === undefined) {
              _vue2.default.set(categoryQuestions[_questionIndex], 'valid', payload.valid);
            } else {
              categoryQuestions[_questionIndex].valid = payload.valid;
            }
          }
        }
      }
    },
    setCategory: function setCategory(state) {
      var newCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.activeCategory;

      state.activeCategory = newCategory;
    },
    setSiteUpdateData: function setSiteUpdateData(state, payload) {
      state.siteUpdates = payload;
    }
  },
  getters: {
    getQuestionLoading: function getQuestionLoading(state) {
      return state.questionLoading;
    },
    getActiveCategoryId: function getActiveCategoryId(state) {
      var activeCategory = state.categories[state.activeCategory];
      if (activeCategory) {
        return activeCategory.id;
      }
    },
    getAssessmentId: function getAssessmentId(state) {
      return state.assessmentId;
    },
    getAnswers: function getAnswers(state) {
      var answers = [];
      if (state.categories.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = state.categories[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = item.questions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var answer = _step3.value;

                answers.push({
                  id: answer.id,
                  answer: answer.answer,
                  display: answer.display
                });
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return answers;
    },
    getCurrentCategoryComment: function getCurrentCategoryComment(state) {
      if (state.categories[state.activeCategory] !== undefined && state.categories[state.activeCategory].comment !== undefined) {
        return state.categories[state.activeCategory].comment;
      }
    },
    getComments: function getComments(state) {
      var comments = [];
      state.categories.forEach(function (category) {

        if (category.comment !== undefined && category.comment.length > 0) {
          var comment = {
            categoryId: category.id,
            comment: category.comment
          };
          comments.push(comment);
        }
      });
      return comments;
    },
    getResultSimulationInfo: function getResultSimulationInfo(state) {
      return state.resultSimulationInfo;
    },
    getSiteUpdates: function getSiteUpdates(state) {
      return state.siteUpdates;
    }
  }
});

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./public/js/store.js
// module id = ./public/js/store.js
// module chunks = 0